<div class="simple-dialog-container">
  <div class="title-container">
    <div class="title">Imagen</div>
    <div class="status">{{ data.image.status }}</div>
  </div>

  <div class="image-container">
    <ng-container
      *ngIf="
        data.image.type.startsWith(fileType.IMAGEN) ||
        data.image.type.startsWith(fileType.IMAGEN_OLD)
      "
    >
      <img alt="{{ data.image.status }}" src="{{ data.image.url }}" />
    </ng-container>
  </div>
</div>
